export * from './dish.query';
export * from './restaurant.query';
export * from './user.query';
export * from './table.query';
export * from './orders.query';
export * from './coupons.query';
export * from './getDeliveryOrder.query';
export * from './groceryStore.query';
